(function () {
  var loaded = false;
  var loading = false;
  var queue = [];

  function injectStylesheet(href, integrity) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    if (integrity) {
      link.integrity = integrity;
      link.crossOrigin = 'anonymous';
    }
    document.head.appendChild(link);
  }

  function loadVendors(done) {
    if (loaded) {
      if (done) {
        done();
      }
      return;
    }
    if (loading) {
      if (done) {
        queue.push(done);
      }
      return;
    }

    loading = true;

    injectStylesheet(
      'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css',
      'sha512-yHknP1/AwR+yx26cB1y0cjvQUMvEa2PFzt1c9LlS4pRQ5NOTZFWbhBig+X9G9eYW/8m0/4OXNx8pxJ6z57x0dw=='
    );
    injectStylesheet(
      'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick-theme.min.css',
      'sha512-17EgCFERpgZKcm0j0fEq1YCJuyAWdz9KUtv1EjVuaOz8pDnh/0nZxmU6BBXwaaxqoi9PQXnRWqlcDB027hgv9A=='
    );

    var jq = document.createElement('script');
    jq.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
    jq.integrity = 'sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo=';
    jq.crossOrigin = 'anonymous';
    jq.onload = function () {
      var slick = document.createElement('script');
      slick.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js';
      slick.integrity = 'sha512-HGOnQO9+SP1V92SrtZfjqxxtLmVzqZpjFFekvzZVWoiASSQgSr4cw9Kqd2+l8Llp4Gm0G8GIFJ4ddwZilcdb8A==';
      slick.crossOrigin = 'anonymous';
      slick.onload = function () {
        loaded = true;
        loading = false;
        if (window.FP && typeof window.FP._flush === 'function') {
          window.FP._flush();
        }
        if (done) {
          done();
        }
        queue.splice(0, queue.length).forEach(function (fn) {
          fn();
        });
      };
      document.body.appendChild(slick);
    };
    document.body.appendChild(jq);
  }

  window.FP = window.FP || {};
  window.FP.loadMeeoowSlick = loadVendors;

  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        loadVendors();
      }, { timeout: 2500 });
    } else {
      loadVendors();
    }
  }

  function observeSliders() {
    var sliders = document.querySelectorAll('.sliders_blocks_bs_ee');
    if (!sliders.length || typeof IntersectionObserver === 'undefined') {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVendors();
          observer.disconnect();
        }
      });
    }, { rootMargin: '200px 0px' });

    sliders.forEach(function (slider) {
      observer.observe(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSliders, { once: true });
  } else {
    observeSliders();
  }

  window.addEventListener('load', schedule, { once: true });
})();
